import React from 'react';
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import {
  Container,
  Label,
  PathContainer,
  Separator,
  Item
} from './styles';

const Breadcrumb = ({ 
  data,
  selectedSubcategory,
  onNavigate
}) => {
  const breadcrumbPath = useBreadcrumb(data, selectedSubcategory);

  const handleClick = (index) => {
    if (index === 0) {
      // Clicked "All" - reset everything
      onNavigate(null);
    } else if (index === breadcrumbPath.length - 1) {
      // Clicked current item - do nothing
      return;
    } else {
      // Clicked middle item - navigate to that category
      onNavigate(breadcrumbPath[index]);
    }
  };

  return (
    <Container>
      <PathContainer>
        {breadcrumbPath.map((item, index) => (
          <React.Fragment key={`${item.id}-${index}`}>
            {index > 0 && <Separator>&gt;</Separator>}
            <Item
              $isActive={index === breadcrumbPath.length - 1}
              $isClickable={index < breadcrumbPath.length - 1}
              onClick={() => index < breadcrumbPath.length - 1 && handleClick(index)}
            >
              {item.name || 'All'}
            </Item>
          </React.Fragment>
        ))}
      </PathContainer>
    </Container>
  );
};

export default Breadcrumb;
